import { Button, ButtonProps } from '@makyoapp/makyo-tw-ui'

export type CompButtonProps = ButtonProps

export const CompButtonCore = Button

// export interface ICompButtonSettings {
//   label: string
//   icon: string | undefined
//   badge: string | undefined
//   wrapperStyle: CSSProperties
//   fullWidth: boolean
//   shape: CornerRadius
//   isTrailing: boolean
//   variant: 'filled' | 'outlined'
//   colorVariant: ColorVariant
//   backgroundColor: ColorVariant
//   styles: CSSProperties
//   disabled: boolean
//   labelTypo: TypographySelectValue
//   margin: Spacing
//   padding: Spacing
//   size: 'sm' | 'md' | 'lg' | 'icon'
// }

// export interface ICompButtonProps {
//   settings: ICompButtonSettings
//   onClick?: React.MouseEventHandler<HTMLButtonElement>
//   id?: string
// }

// /**
//  * TODO: fix the padding from makyo-tw-ui
//  */
// export const CompButtonCore = React.forwardRef<HTMLButtonElement, ICompButtonProps>(
//   ({ settings, onClick, id }, ref) => {
//     return (
//       <div className='block w-full relative' style={settings.wrapperStyle}>
//         <Button
//           ref={ref}
//           style={{
//             ...settings.styles,
//             width: settings.fullWidth ? `var(--md-button-container-width)` : undefined,
//           }}
//           cornerRadius={settings.shape}
//           onClick={onClick}
//           disabled={settings.disabled}
//           trailingIcon={settings.isTrailing}
//           icon={settings.icon ? <MaterialIcon icon={settings.icon} size={24} /> : undefined}
//           colorVariant={settings.colorVariant}
//           labelTypography={settings.labelTypo}
//           margin={settings.margin}
//           padding={settings.padding}
//           preventClickDefault={true}
//           size={settings.size}
//           badgeText={settings.badge}
//           backgroundColor={settings.colorVariant}
//         >
//           <span>{settings.label}</span>
//         </Button>
//       </div>
//     )
//   }
// )
// CompButtonCore.displayName = 'CompButtonCore'
